<template>
  <el-container>
    <el-header>
      <LayoutHeader2></LayoutHeader2>
    </el-header>
    <el-container>
      <el-main>
        <router-view class="router-view"></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// import LayoutAside2 from "./LayoutAside2";
import LayoutHeader2 from "./LayoutHeader2";
import { mapGetters } from "vuex";

export default {
  // components: { LayoutAside2, LayoutHeader },
  components:{LayoutHeader2},
  computed: {
    ...mapGetters(["isCollapse"]),
  },
};
</script>


<style lang="less" scoped>
/deep/ .el-header {
  
  color: #333;
  // height: 50px !important;
  // background-color: #01366e;
  height: 70px !important;
  padding: 0% !important;
}
.el-container{
  height: 100%;
}
/deep/ .el-main {
  // margin: 0 1%;
  // height: 100%;
  padding: 0%;
  margin: 12px 24px 24px 16px;
  border:1px solid rgba(24, 75, 98, 0.75);
  height: calc(100%-38px);
  width: 100%;
}


</style>
<style>
.container-basic {
  width: 100%;
  height: 100%;
  background-color: #07243F;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 100;
}
</style>